import { createReducer, combineReducersWithRoot } from '@common/redux-utils';
import {
  PurchasingActionType,
  SearchPurchasingListStartAction,
  SearchPurchasingListSuccessAction,
  SearchPurchasingListFailureAction,
  GetStatusCountStartAction,
  GetStatusCountSuccessAction,
  GetStatusCountFailureAction,
  GetPurchaseRequestStartAction,
  GetPurchaseRequestSuccessAction,
  GetPurchaseRequestFailureAction,
  SetPurchaseRequestAction,
  SetPurchaseRequestFilesAction,
  DeletePurchaseRequestFileAction,
  SetSupplierAction,
  SetUSStateAction,
  SetColorAction,
  SetIsEditingAction,
  SetPurchasingOwnershipSuccessAction,
  SetPurchasingOwnershipFailureAction,
  SetPurchasingOwnershipStartAction,
  SetAccessoriesAction,
  SetCollectionTypeAction,
  SetHvacSupplierAction,
  SetHvacSystemTypeAction,
  SetHvacPartModelAction,
  SetHvacPickupLocationAction,
  SetHvacDeliveryAddressAction,
  SetHvacVendorTechContactNameAction,
  SetHvacVendorTechContactPhoneAction,
  SetHvacEditItemAction,
  // RemoveHvacItemAction,
  SetHvacItemAction,
  SetHvacSuppliersAction,
  SetHvacSystemTypesAction,
  SetHvacPartModelsAction,
  SetHvacVendorLocationsAction,
  SetHvacUSStatesAction,
  SetHvacLoadingAction,
  SetPartsSavingsAction
} from './purchasing.actions';
import {
  PurchaseRequestViewModel,
  PurchasingRequestStatusesViewModel,
  Accessory,
  PurchaseRequestHvacViewModel,
  CollectionTypes,
  blankPurchaseRequestHvacVM
} from '@models/PurchaseRequest';
import { DocumentViewModel } from '@models/Document';
import { PurchaseRequestSearchViewModel } from '../_models/PurchaseRequest';
import { OptionsViewModel, blankOptionsVM, blankAddressVM, StatesViewModel } from '@models/common.models';
import { PartsReducer, PurchasePartsState, initPurchasePartsState } from 'src/purchasing/purchase-parts.reducer';

export interface PurchasingState {
  readonly purchasingList: Array<PurchaseRequestSearchViewModel>; // TODO: GET PURCHASING VIEW MODEL
  readonly query: string | null;
  readonly filterBy: string | null;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly pageCount: number;
  readonly orderBy: string;
  readonly message: string;
  readonly loading?: boolean;
  readonly statusCount: PurchasingRequestStatusesViewModel;
  readonly purchaseRequest?: PurchaseRequestViewModel;
  readonly documents: DocumentViewModel[];
  readonly selectedSupplierId: number;
  readonly selectedStateAbbreviation: string;
  readonly selectedColor: string;
  readonly isEditing: boolean;
  readonly accessories: Array<Accessory>;
  readonly includeClosed?: boolean | undefined;
  readonly hvacPart: PurchaseRequestHvacViewModel;
  readonly hvacPartIndex: number;
  readonly hvacSuppliers: Array<OptionsViewModel>;
  readonly hvacSystemTypes: Array<OptionsViewModel>;
  readonly hvacPartModels: Array<OptionsViewModel>;
  readonly hvacUSStates: Array<StatesViewModel>;
  readonly hvacVendorLocations: Array<OptionsViewModel>;
  readonly hvacLoading: boolean;
  readonly purchaseParts: PurchasePartsState;
}

export const initialPurchasingState: PurchasingState = {
  purchasingList: [] as Array<any>,
  query: '',
  filterBy: '',
  pageNumber: 0,
  pageSize: 10,
  pageCount: 10,
  orderBy: '',
  message: '',
  statusCount: {} as PurchasingRequestStatusesViewModel,
  documents: [],
  selectedSupplierId: 0,
  selectedStateAbbreviation: '',
  selectedColor: '',
  isEditing: false,
  accessories: [],
  includeClosed: false,
  hvacPart: blankPurchaseRequestHvacVM,
  hvacPartIndex: -1,
  hvacSuppliers: [],
  hvacSystemTypes: [],
  hvacPartModels: [],
  hvacUSStates: [],
  hvacVendorLocations: [],
  hvacLoading: false,
  purchaseParts: initPurchasePartsState
};

/***** Search Purchasing List ****/
function handleSearchPurchasingListStart(
  state: PurchasingState,
  action: SearchPurchasingListStartAction
): PurchasingState {
  return {
    ...state,
    query: action.query,
    includeClosed: action.includeClosed,
    loading: true
  };
}

function handleSearchPurchasingListSuccess(
  state: PurchasingState,
  action: SearchPurchasingListSuccessAction
): PurchasingState {
  return {
    ...state,
    pageNumber: action.pageNumber,
    pageSize: action.result.pageSize,
    pageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    purchasingList: action.result.results,
    orderBy: action.orderBy,
    loading: false
  };
}
function handleSearchPurchasingListFailure(
  state: PurchasingState,
  action: SearchPurchasingListFailureAction
): PurchasingState {
  return {
    ...state,
    message: action.error,
    loading: false
  };
}

/***** Get Status Count *****/

function handleGetStatusCountStart(state: PurchasingState, action: GetStatusCountStartAction): PurchasingState {
  return {
    ...state
  };
}

function handleGetStatusCountSuccess(state: PurchasingState, action: GetStatusCountSuccessAction): PurchasingState {
  return {
    ...state,
    statusCount: action.statusCount
  };
}

function handleGetStatusCountFailure(state: PurchasingState, action: GetStatusCountFailureAction): PurchasingState {
  return {
    ...state
  };
}

/***** Get Status Count *****/

function handleGetPurchaseRequestStart(state: PurchasingState, action: GetPurchaseRequestStartAction): PurchasingState {
  return {
    ...state
  };
}

function handleGetPurchaseRequestSuccess(
  state: PurchasingState,
  action: GetPurchaseRequestSuccessAction
): PurchasingState {
  let supplierId =
    action &&
    action.purchaseRequest &&
    action.purchaseRequest.purchaseRequestInfo &&
    action.purchaseRequest.purchaseRequestInfo.supplier
      ? action.purchaseRequest.purchaseRequestInfo.supplier.id
      : state.selectedSupplierId;
  return {
    ...state,
    purchaseRequest: action.purchaseRequest,
    selectedSupplierId: supplierId
  };
}

function handleGetPurchaseRequestFailure(
  state: PurchasingState,
  action: GetPurchaseRequestFailureAction
): PurchasingState {
  return {
    ...state
  };
}

function handleSetPurchaseRequest(state: PurchasingState, action: SetPurchaseRequestAction): PurchasingState {
  return {
    ...state,
    purchaseRequest: action.purchaseRequest
  };
}

function handleSetPurchaseRequestFiles(state: PurchasingState, action: SetPurchaseRequestFilesAction): PurchasingState {
  return {
    ...state,
    documents: action.documents
  };
}
function handleDeletePurchaseRequestFile(
  state: PurchasingState,
  action: DeletePurchaseRequestFileAction
): PurchasingState {
  if (!action.fileId) {
    return state;
  }
  let documents = state.documents.filter(i => i.id !== action.fileId);
  return {
    ...state,
    documents: documents
  };
}

function handleSetSupplier(state: PurchasingState, action: SetSupplierAction): PurchasingState {
  return {
    ...state,
    selectedSupplierId: action.supplierId
  };
}

function handleSetUSState(state: PurchasingState, action: SetUSStateAction): PurchasingState {
  return {
    ...state,
    selectedStateAbbreviation: action.stateAbbreviation
  };
}

function handleSetColor(state: PurchasingState, action: SetColorAction): PurchasingState {
  return {
    ...state,
    selectedColor: action.color
  };
}

function handleSetIsEditing(state: PurchasingState, action: SetIsEditingAction): PurchasingState {
  return {
    ...state,
    isEditing: action.isEditing
  };
}

function handleSetPurchasingOwnershipStart(
  state: PurchasingState,
  action: SetPurchasingOwnershipStartAction
): PurchasingState {
  return {
    ...state,
    loading: true
  };
}

function handleSetPurchasingOwnershipSuccess(
  state: PurchasingState,
  action: SetPurchasingOwnershipSuccessAction
): PurchasingState {
  let newList: Array<PurchaseRequestSearchViewModel> = [];
  if (state.purchasingList) {
    let list: Array<PurchaseRequestSearchViewModel> = state.purchasingList;
    let result: PurchaseRequestSearchViewModel | undefined = list.find(x => {
      return x.id === action.purchaseRequest.id;
    });
    if (result) {
      const index = list.indexOf(result);
      if (index !== -1) {
        list[index] = action.release
          ? { ...result, owner: { firstName: '', lastName: '', id: 0 } }
          : {
              ...result,
              owner: {
                firstName: action.purchaseRequest.owner.firstName,
                lastName: action.purchaseRequest.owner.lastName,
                id: action.purchaseRequest.owner.id
              }
            };
      }
      // manually sets the owner after ownership change, since ES doesn't update fast enough
    }
    newList = list;
  }
  return {
    ...state,
    loading: false,
    purchasingList: [...newList]
  };
}

function handleSetPurchasingOwnershipFailure(
  state: PurchasingState,
  action: SetPurchasingOwnershipFailureAction
): PurchasingState {
  return {
    ...state,
    loading: false
  };
}

function handleSetAccessories(state: PurchasingState, action: SetAccessoriesAction): PurchasingState {
  return {
    ...state,
    accessories: action.accessories
  };
}

function handleSetHvacItem(state: PurchasingState, action: SetHvacItemAction): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.item = action.item;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacSupplier(state: PurchasingState, action: SetHvacSupplierAction): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.supplier = action.selectedSupplier;
  newHvacPart.systemType = blankOptionsVM;
  newHvacPart.partModel = blankOptionsVM;
  newHvacPart.pickupLocation = blankOptionsVM;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacSystemType(state: PurchasingState, action: SetHvacSystemTypeAction): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.systemType = action.selectedSystemType;
  newHvacPart.partModel = blankOptionsVM;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacPartModel(state: PurchasingState, action: SetHvacPartModelAction): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.partModel = action.selectedPartModel;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetCollectionType(state: PurchasingState, action: SetCollectionTypeAction): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.collectionType = action.selectedCollectionType;

  switch (action.selectedCollectionType) {
    case CollectionTypes.Delivered:
      newHvacPart.pickupLocation = blankOptionsVM;
      break;
    case CollectionTypes.Pickup:
      newHvacPart.deliveryAddress = blankAddressVM;
      newHvacPart.vendorTechContactName = '';
      newHvacPart.vendorTechContactPhone = '';
      newHvacPart.deliveryFee = 0.0;
      break;
    default:
      newHvacPart.deliveryAddress = blankAddressVM;
      newHvacPart.vendorTechContactName = '';
      newHvacPart.vendorTechContactPhone = '';
      newHvacPart.deliveryFee = 0.0;
      newHvacPart.pickupLocation = blankOptionsVM;
      break;
  }

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacDeliveryAddress(state: PurchasingState, action: SetHvacDeliveryAddressAction): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.deliveryAddress = action.deliveryAddress;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacVendorTechContactName(
  state: PurchasingState,
  action: SetHvacVendorTechContactNameAction
): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.vendorTechContactName = action.vendorTechContactName;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacVendorTechContactPhone(
  state: PurchasingState,
  action: SetHvacVendorTechContactPhoneAction
): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.vendorTechContactPhone = action.vendorTechContactPhone;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacPickupLocation(state: PurchasingState, action: SetHvacPickupLocationAction): PurchasingState {
  let newHvacPart = { ...state.hvacPart } as PurchaseRequestHvacViewModel;
  newHvacPart.pickupLocation = action.selectedPickupLocation;

  var newPurchasingState = {
    ...state,
    hvacPart: newHvacPart
  };
  return newPurchasingState;
}

function handleSetHvacEditItem(state: PurchasingState, action: SetHvacEditItemAction): PurchasingState {
  var newPurchasingState = {
    ...state,
    hvacPart: action.hvacPart,
    hvacPartIndex: action.index
  };
  return newPurchasingState;
}

function handleSetHvacSuppliers(state: PurchasingState, action: SetHvacSuppliersAction): PurchasingState {
  if (!action.suppliers) {
    return state;
  }
  return { ...state, hvacSuppliers: action.suppliers };
}

function handleSetHvacSystemTypes(state: PurchasingState, action: SetHvacSystemTypesAction): PurchasingState {
  if (!action.systemTypes) {
    return state;
  }
  return { ...state, hvacSystemTypes: action.systemTypes };
}

function handleSetHvacPartModels(state: PurchasingState, action: SetHvacPartModelsAction): PurchasingState {
  if (!action.partModels) {
    return state;
  }
  return { ...state, hvacPartModels: action.partModels };
}

function handleSetHvacUSStates(state: PurchasingState, action: SetHvacUSStatesAction): PurchasingState {
  if (!action.usStates) {
    return state;
  }
  return { ...state, hvacUSStates: action.usStates };
}

function handleSetHvacVendorLocations(state: PurchasingState, action: SetHvacVendorLocationsAction): PurchasingState {
  if (!action.vendorLocations) {
    return state;
  }
  return { ...state, hvacVendorLocations: action.vendorLocations };
}

function handleSetHvacLoading(state: PurchasingState, action: SetHvacLoadingAction): PurchasingState {
  var newPurchasingState = {
    ...state,
    hvacLoading: action.isLoadingHvac
  };
  return newPurchasingState;
}

function handleSetPartsSavings(state: PurchasingState, action: SetPartsSavingsAction): PurchasingState {
  if (!state.purchaseRequest) {
    return state;
  }
  const newPurchasingState = {
    ...state,
    purchaseRequest: {
      ...state.purchaseRequest,
      purchaseRequestInfo: {
        ...state.purchaseRequest!.purchaseRequestInfo,
        replacementCost: action.replacementCost,
        savings: action.savings
      }
    }
  };
  return newPurchasingState;
}

const reducer = createReducer<PurchasingState, PurchasingActionType>(initialPurchasingState, {
  [PurchasingActionType.SearchPurchasingListStart]: handleSearchPurchasingListStart,
  [PurchasingActionType.SearchPurchasingListSuccess]: handleSearchPurchasingListSuccess,
  [PurchasingActionType.SearchPurchasingListFailure]: handleSearchPurchasingListFailure,

  [PurchasingActionType.GetStatusCountStart]: handleGetStatusCountStart,
  [PurchasingActionType.GetStatusCountSuccess]: handleGetStatusCountSuccess,
  [PurchasingActionType.GetStatusCountFailure]: handleGetStatusCountFailure,

  [PurchasingActionType.GetPurchaseRequestStart]: handleGetPurchaseRequestStart,
  [PurchasingActionType.GetPurchaseRequestSuccess]: handleGetPurchaseRequestSuccess,
  [PurchasingActionType.GetPurchaseRequestFailure]: handleGetPurchaseRequestFailure,

  [PurchasingActionType.SetPurchaseRequest]: handleSetPurchaseRequest,

  [PurchasingActionType.SetPurchaseRequestFiles]: handleSetPurchaseRequestFiles,
  [PurchasingActionType.DeletePurchaseRequestFile]: handleDeletePurchaseRequestFile,

  [PurchasingActionType.SetSupplier]: handleSetSupplier,
  [PurchasingActionType.SetUSState]: handleSetUSState,
  [PurchasingActionType.SetColor]: handleSetColor,

  [PurchasingActionType.SetIsEditing]: handleSetIsEditing,
  [PurchasingActionType.SetPurchasingOwnershipStart]: handleSetPurchasingOwnershipStart,
  [PurchasingActionType.SetPurchasingOwnershipSuccess]: handleSetPurchasingOwnershipSuccess,
  [PurchasingActionType.SetPurchasingOwnershipFailure]: handleSetPurchasingOwnershipFailure,

  [PurchasingActionType.SetAccessories]: handleSetAccessories,

  [PurchasingActionType.SetHvacItem]: handleSetHvacItem,
  [PurchasingActionType.SetHvacSupplier]: handleSetHvacSupplier,
  [PurchasingActionType.SetHvacSystemType]: handleSetHvacSystemType,
  [PurchasingActionType.SetHvacPartModel]: handleSetHvacPartModel,
  [PurchasingActionType.SetCollectionType]: handleSetCollectionType,
  [PurchasingActionType.SetHvacDeliveryAddress]: handleSetHvacDeliveryAddress,
  [PurchasingActionType.SetHvacVendorTechContactName]: handleSetHvacVendorTechContactName,
  [PurchasingActionType.SetHvacVendorTechContactPhone]: handleSetHvacVendorTechContactPhone,
  [PurchasingActionType.SetHvacPickupLocation]: handleSetHvacPickupLocation,
  [PurchasingActionType.SetHvacEditItem]: handleSetHvacEditItem,
  [PurchasingActionType.SetHvacSuppliers]: handleSetHvacSuppliers,
  [PurchasingActionType.SetHvacSystemTypes]: handleSetHvacSystemTypes,
  [PurchasingActionType.SetHvacPartModels]: handleSetHvacPartModels,
  [PurchasingActionType.SetHvacUSStates]: handleSetHvacUSStates,
  [PurchasingActionType.SetHvacVendorLocations]: handleSetHvacVendorLocations,
  [PurchasingActionType.SetHvacLoading]: handleSetHvacLoading,

  [PurchasingActionType.SetPartsSavings]: handleSetPartsSavings
});

export const PurchasingReducer = combineReducersWithRoot(reducer, {
  purchaseParts: PartsReducer
});



// WEBPACK FOOTER //
// ./src/purchasing/purchasing.reducer.ts